import { WindowSize } from '../constants/enums'

export const calculateWindowSize = (width: number, signedIn = false): WindowSize => {
  if (signedIn) {
    if (width > 1320) return WindowSize.DesktopFull
    if (width > 1151) return WindowSize.DesktopLarge
    if (width > 985) return WindowSize.DesktopMedium
    return WindowSize.Mobile
  } else {
    if (width > 1385) return WindowSize.DesktopFull
    if (width > 1235) return WindowSize.DesktopLarge
    if (width > 1075) return WindowSize.DesktopMedium
    return WindowSize.Mobile
  }
}

export const getInitialWindowSize = (): WindowSize => {
  if (typeof window === 'undefined') return WindowSize.DesktopFull
  return calculateWindowSize(window.innerWidth, false)
}
